import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Lock, Shield, AlertTriangle } from 'lucide-react';

const AdminProtectedRoute = ({ children }) => {
  const { isAdmin, isAuthenticated } = useAuth();

  // Si l'utilisateur n'est pas connecté
  if (!isAuthenticated) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1a3d0a 0%, #2d5016 50%, #4a7c59 100%)',
        color: 'white',
        padding: '20px'
      }}>
        <div style={{
          textAlign: 'center',
          maxWidth: '500px',
          padding: '40px',
          borderRadius: '20px',
          background: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.2)'
        }}>
          <Lock size={60} style={{ marginBottom: '20px', opacity: 0.7 }} />
          <h2 style={{ marginBottom: '15px', fontSize: '2rem' }}>Accès Restreint</h2>
          <p style={{ marginBottom: '30px', fontSize: '1.1rem', opacity: 0.9 }}>
            Vous devez être connecté pour accéder à cette page.
          </p>
          <button
            onClick={() => window.location.href = '/'}
            style={{
              background: 'linear-gradient(135deg, #a8d4a8, #7fb87f)',
              color: '#1a3d0a',
              border: 'none',
              padding: '12px 30px',
              borderRadius: '25px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 20px rgba(168, 212, 168, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            Retour à l'accueil
          </button>
        </div>
      </div>
    );
  }

  // Si l'utilisateur n'est pas admin
  if (!isAdmin) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1a3d0a 0%, #2d5016 50%, #4a7c59 100%)',
        color: 'white',
        padding: '20px'
      }}>
        <div style={{
          textAlign: 'center',
          maxWidth: '500px',
          padding: '40px',
          borderRadius: '20px',
          background: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.2)'
        }}>
          <Shield size={60} style={{ marginBottom: '20px', color: '#ff6b6b' }} />
          <h2 style={{ marginBottom: '15px', fontSize: '2rem' }}>Accès Refusé</h2>
          <p style={{ marginBottom: '30px', fontSize: '1.1rem', opacity: 0.9 }}>
            Vous n'avez pas les permissions nécessaires pour accéder à cette page.
          </p>
          <div style={{ marginBottom: '20px', padding: '15px', background: 'rgba(255, 107, 107, 0.1)', borderRadius: '10px', border: '1px solid rgba(255, 107, 107, 0.3)' }}>
            <AlertTriangle size={20} style={{ marginRight: '10px', verticalAlign: 'middle' }} />
            <span>Espace réservé aux administrateurs</span>
          </div>
          <button
            onClick={() => window.location.href = '/'}
            style={{
              background: 'linear-gradient(135deg, #a8d4a8, #7fb87f)',
              color: '#1a3d0a',
              border: 'none',
              padding: '12px 30px',
              borderRadius: '25px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 20px rgba(168, 212, 168, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            Retour à l'accueil
          </button>
        </div>
      </div>
    );
  }

  // Si l'utilisateur est admin, afficher le contenu
  return children;
};

export default AdminProtectedRoute;
